import React, {useEffect,useState} from "react"
import PropTypes from 'prop-types'
import { 
  Row, 
  Col, 
  Dropdown, 
  DropdownToggle, 
  DropdownMenu,
  Label,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Button
 } from "reactstrap"
import { Link } from "react-router-dom"
import classNames from "classnames"
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import * as moment from "moment"

const ReportDayPicker = props => {

  const [menu, setMenu] = useState(false)
  const [enableButton, setEnableButton] = useState(false)
  const [selectedDate, setSelectedDate] = useState('Today')
  const [startDate, setStartDate] = useState(moment(new Date()).format("yyyy-MM-DD"))
  const [endDate, setEndDate] = useState(moment(new Date()).format("yyyy-MM-DD"))
  const [customIconActiveTab, setcustomIconActiveTab] = useState("1")

  function setSelectedOption(option){
    setSelectedDate(option)
    const todayStart = moment(new Date())
    const todayEnd = moment(new Date())
    let startD = todayStart.format("yyyy-MM-DD")
    let endD = todayEnd.format("yyyy-MM-DD")
    if(option == 'Today'){
      //Nothing - already defaulted to today
    }
    else if(option == 'Yesterday'){
      startD = todayStart.subtract(1, 'days').format("yyyy-MM-DD")
      endD = todayEnd.subtract(1, 'days').format("yyyy-MM-DD")
    }
    else if(option == 'This Week'){
      startD = todayStart.startOf('week').format("yyyy-MM-DD")
      //not adding end data, as last date will be today itself
    }
    else if(option == 'Last Week'){
      startD = todayStart.subtract(1, 'week').startOf('week').format("yyyy-MM-DD")
      endD = todayEnd.subtract(1, 'week').endOf('week').format("yyyy-MM-DD")
    }
    else if(option == 'This Month'){
      startD = todayStart.startOf('month').format("yyyy-MM-DD")
      //not adding end data, as last date will be today itself
      //endD = todayEnd.endOf('month').format("yyyy-MM-DD")
    }
    else if(option == 'Last Month'){
      startD = todayStart.subtract(1, 'month').startOf('month').format("yyyy-MM-DD")
      endD = todayEnd.subtract(1, 'month').endOf('month').format("yyyy-MM-DD")
    }
    setStartDate(startD)
    setEndDate(endD)
    setMenu(!menu)

    props.onConfirmSelectedDates({
      startDate : startD,
      endDate : endD
    })
  }

  const handleValidDate = date => {
    return moment(new Date(date)).format("DD MMM Y")
  }

  const toggleIconCustom = tab => {
    if (customIconActiveTab !== tab) {
      setcustomIconActiveTab(tab)
    }
  }

  const confirmDates = () => {
    setSelectedDate('Custom')
    setEnableButton(false)
    setMenu(!menu)
    props.onConfirmSelectedDates({
      startDate : startDate,
      endDate : endDate
    })
  }

  return (
    <React.Fragment>
      <Dropdown
          className="dropdown-mega ms-2"
          isOpen={menu}
          toggle={() => setMenu(!menu)}
          disabled={props.loadInProgress}
        >
          <DropdownToggle
            className="btn  btn-outline-light"
            caret
            tag="button"
          >
            {selectedDate} <i className="mdi mdi-chevron-down" />
          </DropdownToggle>
          <span className="date-picker-selected-dates px-2 py-1" onClick={()=>setMenu(!menu)}>{handleValidDate(startDate)} - {handleValidDate(endDate)}</span>
          
          <Row>
            <Col>
              <DropdownMenu className="dropdown-megamenu">
                <Nav className="nav-tabs-custom nav-justified">
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classNames({
                        active: customIconActiveTab === "1",
                      })}
                      onClick={() => {
                        toggleIconCustom("1")
                      }}
                    >
                      <span className=" ">
                        Presets
                      </span>
                    </NavLink>
                  </NavItem>
                  <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classNames({
                          active: customIconActiveTab === "2",
                        })}
                        onClick={() => {
                          toggleIconCustom("2")
                        }}
                      >
                      <span className=" ">
                        Custom
                      </span>
                      </NavLink>
                    </NavItem>
                </Nav>
                <TabContent
                    activeTab={customIconActiveTab}
                    className="p-3 text-muted"
                  >
                    <TabPane tabId="1">
                      <Row className="mb-1 mx-1">
                        <Col lg={6} className={classNames({"bg-light-blue": selectedDate == 'Today'}," py-2 text-center")}>
                          <Link to="#" 
                            className="off-dark "
                            onClick={() => {
                              setSelectedOption('Today')
                            }}>
                              Today
                          </Link>
                        </Col>
                        <Col lg={6} className={classNames({"bg-light-blue": selectedDate == 'Yesterday'},"py-2 text-center")}>
                          <Link to="#" 
                            className="off-dark "
                            onClick={() => {
                              setSelectedOption('Yesterday')
                            }}>
                              Yesterday
                          </Link>
                        </Col>
                      </Row>
                      <Row className="mb-1 mx-1">
                        <Col lg={6} className={classNames({"bg-light-blue": selectedDate == 'This Week'},"py-2 text-center")}>
                          <Link to="#" 
                            className="off-dark "
                            onClick={() => {
                              setSelectedOption('This Week')
                            }}>
                              This Week
                          </Link>
                        </Col>
                        <Col lg={6} className={classNames({"bg-light-blue": selectedDate == 'Last Week'},"py-2 text-center")}>
                          <Link to="#" 
                            className="off-dark "
                            onClick={() => {
                              setSelectedOption('Last Week')
                            }}>
                              Last Week
                          </Link>
                        </Col>
                      </Row>
                      <Row className="mb-1 mx-1">
                        <Col lg={6} className={classNames({"bg-light-blue": selectedDate == 'This Month'},"py-2 text-center")}>
                          <Link to="#" 
                            className="off-dark "
                            onClick={() => {
                              setSelectedOption('This Month')
                            }}>
                              This Month
                          </Link>
                        </Col>
                        <Col lg={6} className={classNames({"bg-light-blue": selectedDate == 'Last Month'},"py-2 text-center")}>
                          <Link to="#" 
                            className="off-dark "
                            onClick={() => {
                              setSelectedOption('Last Month')
                            }}>
                              Last Month
                          </Link>
                        </Col>
                      </Row>
                    </TabPane>
                    <TabPane tabId="2" className="text-center">
                      <Row className="mb-1 text-center">
                        <Col lg={12} className="text-center">
                          <Flatpickr
                            id="fromandto"
                            className="form-control d-block "
                            placeholder="dd MM yyyy"
                            //value={startDate}
                            options={{
                              altInputClass : "invisible",
                              mode:"range",
                              inline: true,
                              altInput: true,
                              altFormat: "j M Y",
                              dateFormat: "Y-m-d",
                              maxDate: "today",
                              defaultDate: [startDate, endDate]
                            }}
                            onChange={date => {
                              //console.log('date::'+date)
                              if(date.length == 1){
                                const date1 = moment(new Date(date[0])).format("yyyy-MM-DD")
                                setStartDate(date1)
                              }
                              else if(date.length == 2){
                                const date1 = moment(new Date(date[0])).format("yyyy-MM-DD")
                                setStartDate(date1)
                                const date2 = moment(new Date(date[1])).format("yyyy-MM-DD")
                                setEndDate(date2)
                                setEnableButton(true)
                              }
                            }}
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={12} className="text-center">
                          <Button
                            type="button"
                            color="primary"
                            className="btn btn-primary w-lg mt-2"
                            onClick={() => {
                              confirmDates()
                            }}
                            disabled={!enableButton}
                          >
                            Confirm
                          </Button>
                        </Col>
                      </Row>
                    </TabPane>
                </TabContent>
                
              </DropdownMenu>
            </Col>
          </Row>
        </Dropdown>
      </React.Fragment>
  )
}

ReportDayPicker.propTypes = {
  onConfirmSelectedDates : PropTypes.func,
  loadInProgress : PropTypes.bool
}

export default ReportDayPicker
